import { configureStore } from '@reduxjs/toolkit'
import cartReducer from './cartSlice'

/** Global Redux store configuration. */
export const store = configureStore({
  reducer: {
    cart: cartReducer,
  },
})

/** Root state type derived from the store. */
export type RootState = ReturnType<typeof store.getState>
/** App dispatch type derived from the store. */
export type AppDispatch = typeof store.dispatch
